import React, { useState, useEffect } from 'react';
import config from '../config';

const ToolFrame = ({ app }) => {
  const [loading, setLoading] = useState(true);

  const authToken = localStorage.getItem(config.tokenKey) || '';

  const buildUrl = () => {
    if (!app.url || app.url.startsWith('{{')) return '';
    const base = app.url.trim();
    const sep  = base.includes('?') ? '&' : '?';
    const sourceProject = app.request?.sourceProject
      ? `&source_project=${encodeURIComponent(app.request.sourceProject)}`
      : '';
    return `${base}${sep}token=${encodeURIComponent(authToken)}${sourceProject}&v=${Date.now()}`;
  };

  const iframeUrl = buildUrl();

  useEffect(() => {
    setLoading(true);
  }, [app.key, app.request?.nonce]);

  if (!iframeUrl) {
    return (
      <div style={styles.placeholder}>
        <p>⚠️ URL non configurée pour <strong>{app.label}</strong></p>
        <small>Renseigne l'URL dans <code>config.js</code></small>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      {loading && (
        <div style={styles.loader}>
          <p>Chargement de {app.label}...</p>
        </div>
      )}
      <iframe
        key={`${app.key}-${app.request?.nonce || 'default'}`}
        src={iframeUrl}
        style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
        title={app.label}
        onLoad={() => setLoading(false)}
        allowFullScreen
        allow="clipboard-write; clipboard-read; fullscreen; accelerometer; gyroscope; camera; microphone"
      />
    </div>
  );
};

const styles = {
  loader: {
    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#20242c', zIndex: 10, color: '#f5f6f7'
  },
  placeholder: {
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    height: '100%', color: '#aaa', gap: '10px'
  }
};

export default ToolFrame;
